import { render, staticRenderFns } from "./CompleteTaskModal.vue?vue&type=template&id=0c72d006&scoped=true&"
import script from "./CompleteTaskModal.vue?vue&type=script&lang=js&"
export * from "./CompleteTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./CompleteTaskModal.vue?vue&type=style&index=0&id=0c72d006&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72d006",
  null
  
)

export default component.exports